(() => {
  const ready = (callback) => {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', callback, { once: true });
    } else {
      callback();
    }
  };

  ready(() => {
    const header = document.querySelector('.section-header');
    if (header) {
      const setHeaderState = () => header.classList.toggle('es-header--scrolled', window.scrollY > 24);
      setHeaderState();
      window.addEventListener('scroll', setHeaderState, { passive: true });
    }

    document.querySelectorAll('[data-es-scroll]').forEach((link) => {
      link.addEventListener('click', (event) => {
        const target = document.querySelector(link.getAttribute('href'));
        if (!target) return;
        event.preventDefault();
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
    });

    document.querySelectorAll('[data-es-accordion]').forEach((group) => {
      group.addEventListener('toggle', () => {
        if (!group.open) return;
        const parent = group.closest('[data-es-accordion-group]');
        if (!parent) return;
        parent.querySelectorAll('[data-es-accordion][open]').forEach((item) => {
          if (item !== group) item.removeAttribute('open');
        });
      });
    });
  });
})();
